export const municipios = [
  { name: "Acambay de Ruiz Castaneda", value: 1 , district_id:14},
  { name: "Acolman", value: 2 , district_id:39},
  { name: "Aculco", value: 3 , district_id:14},
  { name: "Almoloya de Alquisiras", value: 4 , district_id:9},
  { name: "Almoloya de Juarez", value: 5 , district_id:45},
  { name: "Almoloya del Rio", value: 6 , district_id:7},
  { name: "Amanalco", value: 7 , district_id:10},
  { name: "Amatepec", value: 8 , district_id:9},
  { name: "Amecameca", value: 9 , district_id:28},
  { name: "Apaxco", value: 10, district_id:20 },
  { name: "Atenco", value: 11, district_id:23 },
  { name: "Atizapan de Zaragoza", value: 12, district_id:29 },
  { name: "Atizapan", value: 13, district_id:4 },
  { name: "Atlacomulco", value: 14, district_id:13 },
  { name: "Atlautla", value: 15, district_id:28 },
  { name: "Axapusco", value: 16, district_id:39 },
  { name: "Ayapango", value: 17, district_id:28 },
  { name: "Calimaya", value: 18, district_id:7 },
  { name: "Capulhuac", value: 19, district_id:4 },
  { name: "Chalco", value: 20, district_id:1},
  { name: "Chapa de Mota", value: 21, district_id:14 },
  { name: "Chapultepec", value: 22, district_id:35 },
  { name: "Chiautla", value: 23, district_id:39 },
  { name: "Chicoloapan", value: 24, district_id:5 },
  { name: "Chiconcuac", value: 25, district_id:23 },
  { name: "Chimalhuacan", value: 26, district_id:3 },
  { name: "Coacalco de Berriozabal", value: 27, district_id:38 },
  { name: "Coatepec Harinas", value: 28, district_id:9 },
  { name: "Cocotitlan", value: 29, district_id:1 },
  { name: "Coyotepec", value: 30, district_id:12 },
  { name: "Cuautitlan Izcalli", value: 31, district_id:26 },
  { name: "Cuautitlan", value: 32, district_id:12 },
  { name: "Donato Guerra", value: 33, district_id:10 },
  { name: "Ecatepec de Morelos", value: 34, district_id:6 },
  { name: "Ecatzingo", value: 35, district_id:28 },
  { name: "El Oro", value: 36, district_id:13 },
  { name: "Huehuetoca", value: 37, district_id:20 },
  { name: "Hueypoxtla", value: 38, district_id:20 },
  { name: "Huixquilucan", value: 39, district_id:17 },
  { name: "Isidro Fabela", value: 40, district_id:17 },
  { name: "Ixtapaluca", value: 41, district_id:28 },
  { name: "Ixtapan de la Sal", value: 42, district_id:9 },
  { name: "Ixtapan del Oro", value: 43, district_id:10 },
  { name: "Ixtlahuaca", value: 44, district_id:15 },
  { name: "Jaltenco", value: 45, district_id:12 },
  { name: "Jilotepec", value: 46, district_id:14 },
  { name: "Jilotzingo", value: 47, district_id:17 },
  { name: "Jiquipilco", value: 48, district_id:15 },
  { name: "Jocotitlan", value: 49, district_id:13 },
  { name: "Joquicingo", value: 50, district_id:7 },
  { name: "Juchitepec", value: 51, district_id:28 },
  { name: "La Paz", value: 52, district_id:31 },
  { name: "Lerma", value: 53, district_id:4 },
  { name: "Luvianos", value: 54, district_id:9 },
  { name: "Malinalco", value: 55, district_id:7 },
  { name: "Melchor Ocampo", value: 56, district_id:12 },
  { name: "Metepec", value: 57, district_id:35 },
  { name: "Mexicaltzingo", value: 58, district_id:35 },
  { name: "Morelos", value: 59, district_id:14 },
  { name: "Naucalpan de Juarez", value: 60, district_id:29 },
  { name: "Nextlalpan", value: 61, district_id:12 },
  { name: "Nezahualcoyotl", value: 62, district_id:25},
  { name: "Nicolas Romero", value: 63, district_id:44 },
  { name: "Nopaltepec", value: 64, district_id:39},
  { name: "Ocoyoacac", value: 65, district_id:4 },
  { name: "Ocuilan", value: 66, district_id:7 },
  { name: "Otumba", value: 67, district_id:39 },
  { name: "Otzoloapan", value: 68, district_id:10 },
  { name: "Otzolotepec", value: 69, district_id:34 },
  { name: "Ozumba", value: 70, district_id:28 },
  { name: "Papalotla", value: 71, district_id:39 },
  { name: "Polotitlan", value: 72, district_id:14 },
  { name: "Rayon", value: 73, district_id:7 },
  { name: "San Antonio la Isla", value: 74, district_id:7 },
  { name: "San Felipe del Progreso", value: 75, district_id:14 },
  { name: "San Jose del Rincon", value: 76, district_id:13 },
  { name: "San Martin de las Piramides", value: 77, district_id:39 },
  { name: "San Mateo Atenco", value: 78, district_id:35 },
  { name: "San Simon de Guerrero", value: 79, district_id:10},
  { name: "Santo Tomas", value: 80, district_id:10 },
  { name: "Soyaniquilpan de Juarez", value: 81, district_id:14 },
  { name: "Sultepec", value: 82, district_id:9 },
  { name: "Tecamac", value: 83, district_id:33 },
  { name: "Tejupilco", value: 84, district_id:9 },
  { name: "Temamatla", value: 85, district_id:1 },
  { name: "Temascalapa", value: 86, district_id:39 },
  { name: "Temascalcingo", value: 87, district_id:13 },
  { name: "Temascaltepec", value: 88, district_id:10 },
  { name: "Temoaya", value: 89, district_id:5 },
  { name: "Tenancingo", value: 90, district_id:7 },
  { name: "Tenango del Aire", value: 91, district_id:28 },
  { name: "Tenango del Valle", value: 92, district_id:7 },
  { name: "Teoloyucan", value: 93, district_id:12 },
  { name: "Teotihuacan", value: 94, district_id:39 },
  { name: "Tepetlaoxtoc", value: 95, district_id:39 },
  { name: "Tepetlixpa", value: 96, district_id:28 },
  { name: "Tepotzotlan", value: 97, district_id:12 },
  { name: "Tequixquiac", value: 98, district_id:20},
  { name: "Texcaltitlan", value: 99, district_id:10 },
  { name: "Texcalyacac", value: 100, district_id:4},
  { name: "Texcoco", value: 101, district_id:23 },
  { name: "Tezoyuca", value: 102, district_id:23 },
  { name: "Tianguistenco", value: 103, district_id:4 },
  { name: "Timilpan", value: 104, district_id:14 },
  { name: "Tlalmanalco", value: 105, district_id:28 },
  { name: "Tlalnepantla de Baz", value: 106, district_id:18 },
  { name: "Tlatlaya", value: 107, district_id:9 },
  { name: "Toluca", value: 108, district_id:2 },
  { name: "Tonanitla", value: 109, district_id:12 },
  { name: "Tonatico", value: 110, district_id:9 },
  { name: "Tultepec", value: 111, district_id:19 },
  { name: "Tultitlan", value: 112, district_id:11 },
  { name: "Valle de Bravo", value: 113, district_id:10 },
  { name: "Valle de Chalco Solidaridad", value: 114, district_id:27 },
  { name: "Villa Guerrero", value: 115, district_id:9 },
  { name: "Villa Victoria", value: 116, district_id:10 },
  { name: "Villa de Allende", value: 117, district_id:10 },
  { name: "Villa del Carbon", value: 118, district_id:14 },
  { name: "Xalatlaco", value: 119, district_id:4 },
  { name: "Xonacatlan", value: 120, district_id:17 },
  { name: "Zacazonapan", value: 121, district_id:10 },
  { name: "Zacualpan", value: 122, district_id:9 },
  { name: "Zinacantepec", value: 123, district_id:36 },
  { name: "Zumpahuacan", value: 124, district_id:7 },
  { name: "Zumpango", value: 125, district_id:20 },
];
